import { DEBUG_PLAYBACK_RATE } from 'constants/events';
import * as analytics from 'utilities/analytics';

import {
  EMOJI_CLICKED_IN_VIDEO_PLAYER,
  FETCH_VIDEO_PLAYER_VIDEO,
  REQUEST_VIDEO_PLAYER_CURRENT_TIME,
  REQUEST_VIDEO_PLAYER_ENTER_FULL_SCREEN,
  REQUEST_VIDEO_PLAYER_LEAVE_FULL_SCREEN,
  REQUEST_VIDEO_PLAYER_MUTE,
  REQUEST_VIDEO_PLAYER_PAUSE,
  REQUEST_VIDEO_PLAYER_PLAY,
  REQUEST_VIDEO_PLAYER_PLAYBACK_RATE,
  REQUEST_VIDEO_PLAYER_SEEKTO_TS,
  REQUEST_VIDEO_PLAYER_UNMUTE,
  REQUEST_VIDEO_PLAYER_VOLUME,
  SET_CURRENT_CAPTION,
  UDPATE_IS_FROM_SLACK_DESKTOP_APP,
  UPDATE_CAPTIONS_DETAILS,
  UPDATE_CAPTIONS_VISIBLE,
  UPDATE_CHROME_PIP_ENABLED,
  UPDATE_FILLER_WORD_HIGHLIGHT,
  UPDATE_FILLER_WORDS,
  UPDATE_FROM_PUBLIC_SHARE_PAGE,
  UPDATE_IS_FILLER_REMOVAL_FTUX,
  UPDATE_IS_INLINE_EMBED_ON_LOOM,
  UPDATE_IS_TRIMMING_FILLER_WORDS,
  UPDATE_PIP_SUPPORTED,
  UPDATE_SAFARI_PIP_ENABLED,
  UPDATE_SHARE_VIDEO_IN_UPLOAD_MODE,
  UPDATE_TRANSCRIPT_STATUS_ON_PLAYER,
  UPDATE_TRANSCRIPT_VISIBLE,
  UPDATE_VIDEO_FRAME_HEIGHT,
  UPDATE_VIDEO_PLAYER_ACTIVE_COMMENT_BUCKET_INDEX,
  UPDATE_VIDEO_PLAYER_AUTOPLAY,
  UPDATE_VIDEO_PLAYER_BUCKET_ID,
  UPDATE_VIDEO_PLAYER_BUFFERED_PARTS,
  UPDATE_VIDEO_PLAYER_COMMENT_MARKERS,
  UPDATE_VIDEO_PLAYER_CURRENT_TIME,
  UPDATE_VIDEO_PLAYER_DIMENSIONS,
  UPDATE_VIDEO_PLAYER_DURATION,
  UPDATE_VIDEO_PLAYER_EMOJI_BAR_HIDE_REACTION,
  UPDATE_VIDEO_PLAYER_ENDED,
  UPDATE_VIDEO_PLAYER_ENTER_FULL_SCREEN,
  UPDATE_VIDEO_PLAYER_FLIPPED_CAMERA,
  UPDATE_VIDEO_PLAYER_FROM_LINK_EXPAND,
  UPDATE_VIDEO_PLAYER_HOVERED_COMMENT_BUCKET_INDEX,
  UPDATE_VIDEO_PLAYER_IN_ANONYMOUS_REACTION_MODE,
  UPDATE_VIDEO_PLAYER_IN_COMMENT_MODE,
  UPDATE_VIDEO_PLAYER_LEAVE_FULL_SCREEN,
  UPDATE_VIDEO_PLAYER_LOCAL_REACTIONS,
  UPDATE_VIDEO_PLAYER_MOUSE_ACTIVE,
  UPDATE_VIDEO_PLAYER_MOUSE_INACTIVE,
  UPDATE_VIDEO_PLAYER_MUTE,
  UPDATE_VIDEO_PLAYER_NAME,
  UPDATE_VIDEO_PLAYER_NEEDS_PASSWORD,
  UPDATE_VIDEO_PLAYER_NOT_ENDED,
  UPDATE_VIDEO_PLAYER_NOT_WAITING,
  UPDATE_VIDEO_PLAYER_OWNER,
  UPDATE_VIDEO_PLAYER_PARENT_LOCATION,
  UPDATE_VIDEO_PLAYER_PASSWORD,
  UPDATE_VIDEO_PLAYER_PAUSED,
  UPDATE_VIDEO_PLAYER_PLAIN_SOURCE_URL,
  UPDATE_VIDEO_PLAYER_PLAY,
  UPDATE_VIDEO_PLAYER_PLAYBACK_RATE,
  UPDATE_VIDEO_PLAYER_PLAYING,
  UPDATE_VIDEO_PLAYER_PLAYING_PAUSED,
  UPDATE_VIDEO_PLAYER_POSTER_URL,
  UPDATE_VIDEO_PLAYER_REACTIONS_LOADED,
  UPDATE_VIDEO_PLAYER_REACTIONS_REMOVE,
  UPDATE_VIDEO_PLAYER_SEEKING,
  UPDATE_VIDEO_PLAYER_SHOW_COMMENTS,
  UPDATE_VIDEO_PLAYER_SOURCE,
  UPDATE_VIDEO_PLAYER_SOURCE_FROM_CLIP,
  UPDATE_VIDEO_PLAYER_THEATER_MODE,
  UPDATE_VIDEO_PLAYER_UNMUTE,
  UPDATE_VIDEO_PLAYER_VIDEO,
  UPDATE_VIDEO_PLAYER_VOLUME,
  UPDATE_VIDEO_PLAYER_VOLUME_CONTROL_ACTIVE,
  UPDATE_VIDEO_PLAYER_WAITING,
  UPDATE_VIDEO_PROCESSING_ERROR,
  UPDATE_VIDEO_VIEWER_NEEDS_PERMISSION,
  UPLOAD_VIDEO_PROGRESS,
  VIDEO_PLAYER_EMOJI_SELECTED,
  VIDEO_PLAYER_EMOJI_SELECTED_RESET,
  VIDEO_PLAYER_EMOJI_SELECTED_SAVED,
  VIDEO_READY_TO_PLAY_ON_SHARE_PAGE,
} from '../constants/actions';

import { PLAYBACK_RATES } from 'components/video-player/constants/playback';

export const fetchVideoPlayerVideo = () => {
  return { type: FETCH_VIDEO_PLAYER_VIDEO };
};

export const requestVideoPlayerSeekToTs = ts => {
  return { type: REQUEST_VIDEO_PLAYER_SEEKTO_TS, ts };
};

export const requestVideoPlayerCurrentTime = currentTime => {
  if (currentTime < 0) {
    currentTime = 0;
  }

  return { type: REQUEST_VIDEO_PLAYER_CURRENT_TIME, currentTime };
};

export const requestVideoPlayerEnterFullScreen = () => {
  return { type: REQUEST_VIDEO_PLAYER_ENTER_FULL_SCREEN };
};

export const requestVideoPlayerLeaveFullScreen = () => {
  return { type: REQUEST_VIDEO_PLAYER_LEAVE_FULL_SCREEN };
};

export const updateTheaterMode = (theaterMode, inTrimMode) => {
  if (theaterMode && inTrimMode) {
    return {
      type: UPDATE_VIDEO_PLAYER_THEATER_MODE,
      theaterMode: false,
    };
  }

  return {
    type: UPDATE_VIDEO_PLAYER_THEATER_MODE,
    theaterMode,
  };
};

export const requestVideoPlayerMute = () => {
  return { type: REQUEST_VIDEO_PLAYER_MUTE };
};

export const requestVideoPlayerPause = () => {
  return { type: REQUEST_VIDEO_PLAYER_PAUSE };
};

export const requestVideoPlayerPlay = (playAfterSeek = false) => {
  return { type: REQUEST_VIDEO_PLAYER_PLAY, playAfterSeek };
};

export const requestVideoPlayerPlaybackRate = rate => {
  let playbackRate = rate;

  // TEMP (claudio): debugging faulty playback rate
  if (!PLAYBACK_RATES.includes(playbackRate)) {
    analytics.track(DEBUG_PLAYBACK_RATE, {
      playbackRate,
      requested: true,
    });
    playbackRate = closestRate(playbackRate);
  }

  return {
    type: REQUEST_VIDEO_PLAYER_PLAYBACK_RATE,
    playbackRate,
  };
};

export const requestVideoPlayerUnmute = () => {
  return { type: REQUEST_VIDEO_PLAYER_UNMUTE };
};

export const requestVideoPlayerVolume = volume => {
  return { type: REQUEST_VIDEO_PLAYER_VOLUME, volume };
};

export const updateFromPublicSharePage = fromPublicSharePage => {
  return {
    type: UPDATE_FROM_PUBLIC_SHARE_PAGE,
    fromPublicSharePage,
  };
};

export const updateIsInlineEmbedOnLoom = isInlineEmbedOnLoom => {
  return {
    type: UPDATE_IS_INLINE_EMBED_ON_LOOM,
    isInlineEmbedOnLoom,
  };
};

export const updateIsFromSlackDesktopApp = isFromSlackDesktopApp => {
  return {
    type: UDPATE_IS_FROM_SLACK_DESKTOP_APP,
    isFromSlackDesktopApp,
  };
};

export const updateVideoPlayerBufferedParts = (bufferedParts = []) => {
  return {
    type: UPDATE_VIDEO_PLAYER_BUFFERED_PARTS,
    bufferedParts,
  };
};

export const updateVideoPlayerAutoplay = (autoplay = false) => {
  return {
    type: UPDATE_VIDEO_PLAYER_AUTOPLAY,
    autoplay,
  };
};

export const updateVideoPlayerCommentMarkers = commentMarkers => {
  return {
    type: UPDATE_VIDEO_PLAYER_COMMENT_MARKERS,
    commentMarkers,
  };
};

export const updateVideoPlayerActiveCommentBucketIndex = bucketIndex => {
  return {
    type: UPDATE_VIDEO_PLAYER_ACTIVE_COMMENT_BUCKET_INDEX,
    bucketIndex,
  };
};

export const updateVideoPlayerHoveredCommentBucketIndex = bucketIndex => {
  return {
    type: UPDATE_VIDEO_PLAYER_HOVERED_COMMENT_BUCKET_INDEX,
    bucketIndex,
  };
};

export const updateVideoPlayerCurrentTime = currentTime => {
  return {
    type: UPDATE_VIDEO_PLAYER_CURRENT_TIME,
    current_time: currentTime,
  };
};

export const updateVideoPlayerDimensions = (width = 0, height = 0) => {
  return {
    type: UPDATE_VIDEO_PLAYER_DIMENSIONS,
    height,
    width,
  };
};

export const updateVideoPlayerDuration = duration => {
  return {
    type: UPDATE_VIDEO_PLAYER_DURATION,
    duration,
  };
};

export const updateVideoPlayerEnded = () => {
  return { type: UPDATE_VIDEO_PLAYER_ENDED };
};

export const updateVideoPlayerNotEnded = () => {
  return { type: UPDATE_VIDEO_PLAYER_NOT_ENDED };
};

export const updateVideoPlayerEnterFullScreen = () => {
  return { type: UPDATE_VIDEO_PLAYER_ENTER_FULL_SCREEN };
};

export const updateVideoPlayerFlippedCamera = flippedCamera => {
  return {
    type: UPDATE_VIDEO_PLAYER_FLIPPED_CAMERA,
    flippedCamera,
  };
};

export const updateVideoPlayerFromLinkExpand = fromLinkExpand => {
  return {
    type: UPDATE_VIDEO_PLAYER_FROM_LINK_EXPAND,
    fromLinkExpand,
  };
};

export const updateVideoPlayerLeaveFullScreen = () => {
  return { type: UPDATE_VIDEO_PLAYER_LEAVE_FULL_SCREEN };
};

export const updateVideoPlayerMouseActive = () => {
  return { type: UPDATE_VIDEO_PLAYER_MOUSE_ACTIVE };
};

export const updateVideoPlayerMouseInactive = () => {
  return { type: UPDATE_VIDEO_PLAYER_MOUSE_INACTIVE };
};

export const updateVideoPlayerMute = () => {
  return { type: UPDATE_VIDEO_PLAYER_MUTE };
};

export const updateVideoPlayerNeedsPassword = needsPassword => {
  return { type: UPDATE_VIDEO_PLAYER_NEEDS_PASSWORD, needsPassword };
};

export const updateVideoViewerNeedsPermission = needsPermission => {
  return { type: UPDATE_VIDEO_VIEWER_NEEDS_PERMISSION, needsPermission };
};

export const updateVideoPlayerNotWaiting = () => {
  return { type: UPDATE_VIDEO_PLAYER_NOT_WAITING };
};

export const updateVideoPlayerParentLocation = parentLocation => {
  return {
    type: UPDATE_VIDEO_PLAYER_PARENT_LOCATION,
    parent_location: parentLocation,
  };
};

export const updateVideoPlayerPassword = password => {
  return { type: UPDATE_VIDEO_PLAYER_PASSWORD, password };
};

export const updateVideoPlayerPaused = () => {
  return { type: UPDATE_VIDEO_PLAYER_PAUSED };
};

export const updateVideoPlayerPlay = () => {
  return { type: UPDATE_VIDEO_PLAYER_PLAY };
};

export const updateVideoPlayerPlaying = () => {
  return { type: UPDATE_VIDEO_PLAYER_PLAYING };
};

export const updateVideoPlayerPlaybackRate = playbackRate => {
  // TEMP (claudio): debugging faulty playback rate
  if (!PLAYBACK_RATES.includes(playbackRate)) {
    analytics.track(DEBUG_PLAYBACK_RATE, {
      playbackRate,
    });
  }

  // TEMP (clinton): we are getting a playback rate of 0 at times
  // If we get 0, we should default to 1.
  if (playbackRate === 0) {
    playbackRate = 1;
  }

  return {
    type: UPDATE_VIDEO_PLAYER_PLAYBACK_RATE,
    playbackRate,
  };
};

export const updateVideoPlayerPosterUrl = posterUrl => {
  return {
    type: UPDATE_VIDEO_PLAYER_POSTER_URL,
    posterUrl,
  };
};

export const updateVideoPlayerPlainSourceUrl = plainSourceUrl => {
  return {
    type: UPDATE_VIDEO_PLAYER_PLAIN_SOURCE_URL,
    plainSourceUrl,
  };
};

export const updateVideoPlayerSeeking = (seeking, playAfterSeek) => {
  return {
    type: UPDATE_VIDEO_PLAYER_SEEKING,
    seeking,
    playAfterSeek,
  };
};

export const updateVideoPlayerSource = ({
  sourceUrl,
  sourceMimeType,
  partCredentials,
  sourceUrlIsTranscoded,
}) => {
  return {
    type: UPDATE_VIDEO_PLAYER_SOURCE,
    partCredentials,
    sourceMimeType,
    sourceUrl,
    sourceUrlIsTranscoded,
  };
};

export const updateVideoPlayerSourceFromClip = ({
  sourceUrl,
  sourceMimeType,
  partCredentials,
  sourceUrlIsTranscoded,
  autoplay = false,
}) => {
  return {
    type: UPDATE_VIDEO_PLAYER_SOURCE_FROM_CLIP,
    sourceUrl,
    sourceMimeType,
    partCredentials,
    sourceUrlIsTranscoded,
    autoplay,
  };
};

export const updateVideoPlayerUnmute = () => {
  return { type: UPDATE_VIDEO_PLAYER_UNMUTE };
};

export const updateVideoPlayerVolume = volume => {
  return {
    type: UPDATE_VIDEO_PLAYER_VOLUME,
    volume,
  };
};

export const updateVideoPlayerVideo = video => {
  return {
    type: UPDATE_VIDEO_PLAYER_VIDEO,
    video,
  };
};

export const updateVideoProcessingError = (
  videoUploadValid,
  videoUploadMessage
) => {
  return {
    type: UPDATE_VIDEO_PROCESSING_ERROR,
    videoUploadValid,
    videoUploadMessage,
  };
};

export const updateVideoPlayerWaiting = () => {
  return { type: UPDATE_VIDEO_PLAYER_WAITING };
};

export const updateVideoPlayerLocalReactions = reactions => {
  return { type: UPDATE_VIDEO_PLAYER_LOCAL_REACTIONS, reactions };
};

export const updateVideoPlayerReactions = reactions => {
  return { type: UPDATE_VIDEO_PLAYER_REACTIONS_LOADED, reactions };
};

export const updateVideoPlayerRemoveReaction = reactionId => {
  return { type: UPDATE_VIDEO_PLAYER_REACTIONS_REMOVE, id: reactionId };
};

export const updateVideoPlayerHideReaction = reaction => {
  return {
    type: UPDATE_VIDEO_PLAYER_EMOJI_BAR_HIDE_REACTION,
    reaction,
  };
};

export const updateVideoPlayerEmojiSelected = (localId, type, reaction) => {
  return {
    type: VIDEO_PLAYER_EMOJI_SELECTED,
    ids: [localId],
    hideReaction: type,
    reaction,
  };
};

export const updateVideoPlayerEmojiSelectedSaved = (reactionId, localId) => {
  return {
    type: VIDEO_PLAYER_EMOJI_SELECTED_SAVED,
    id: reactionId,
    localId,
  };
};

export const updateVideoPlayerEmojiSelectedReset = () => {
  return { type: VIDEO_PLAYER_EMOJI_SELECTED_RESET };
};

export const updateVideoPlayerVolumeControlActive = active => ({
  type: UPDATE_VIDEO_PLAYER_VOLUME_CONTROL_ACTIVE,
  active,
});

export const uploadVideoProgress = progress => {
  return {
    type: UPLOAD_VIDEO_PROGRESS,
    progress,
  };
};

export const updateShareVideoInUploadMode = inUploadMode => {
  return {
    type: UPDATE_SHARE_VIDEO_IN_UPLOAD_MODE,
    inUploadMode,
  };
};

export const updateVideoPlayerInCommentMode = (
  inCommentMode,
  resumeAfterComment = false
) => {
  return {
    type: UPDATE_VIDEO_PLAYER_IN_COMMENT_MODE,
    inCommentMode,
    resumeAfterComment,
  };
};

export const updateVideoPlayerInAnonymousReactionMode =
  inAnonymousReactionMode => {
    return {
      type: UPDATE_VIDEO_PLAYER_IN_ANONYMOUS_REACTION_MODE,
      inAnonymousReactionMode,
    };
  };

export const updateVideoPlayerBucketId = bucketId => {
  return {
    type: UPDATE_VIDEO_PLAYER_BUCKET_ID,
    bucketId,
  };
};

export const updateVideoPlayerShowComments = (
  showAllComments,
  bucketId,
  resumeOnExit
) => {
  return {
    type: UPDATE_VIDEO_PLAYER_SHOW_COMMENTS,
    showAllComments,
    bucketId,
    resumeOnExit,
  };
};

export const updatePipSupported = pipSupported => {
  return {
    type: UPDATE_PIP_SUPPORTED,
    pipSupported,
  };
};

export const updateChromePipEnabled = chromePipEnabled => {
  return {
    type: UPDATE_CHROME_PIP_ENABLED,
    chromePipEnabled,
  };
};

export const updateSafariPipEnabled = safariPipEnabled => {
  return {
    type: UPDATE_SAFARI_PIP_ENABLED,
    safariPipEnabled,
  };
};

export const startVideoWithoutPlaying = () => {
  return {
    type: UPDATE_VIDEO_PLAYER_PLAYING_PAUSED,
  };
};

export const toggleTranscriptVisible = (transcriptVisible = false) => {
  return {
    type: UPDATE_TRANSCRIPT_VISIBLE,
    transcriptVisible,
  };
};

export const toggleCaptionsVisible = (captionsVisible = false) => {
  return {
    type: UPDATE_CAPTIONS_VISIBLE,
    captionsVisible,
  };
};

function closestRate(rate = 0) {
  if (Number.isNaN(rate)) {
    rate = 0;
  }

  return PLAYBACK_RATES.reduce((a, b) => {
    return Math.abs(b - rate) < Math.abs(a - rate) ? b : a;
  });
}

export const videoReadyToPlayOnSharePage = () => {
  return { type: VIDEO_READY_TO_PLAY_ON_SHARE_PAGE };
};

export const updateEmojiClickedInVideoPlayer = (
  emojiClickedInVideoPlayer = true
) => {
  return { type: EMOJI_CLICKED_IN_VIDEO_PLAYER, emojiClickedInVideoPlayer };
};

export const updateVideoPlayerHeight = videoFrameHeight => {
  return { type: UPDATE_VIDEO_FRAME_HEIGHT, videoFrameHeight };
};

export const updateCaptionsDetails = captionsDetails => {
  return { type: UPDATE_CAPTIONS_DETAILS, captionsDetails };
};

export const setCurrentCaption = caption => {
  return { type: SET_CURRENT_CAPTION, caption };
};

export const updateTranscriptStatusOnVideoPlayer = transcriptStatus => {
  return { type: UPDATE_TRANSCRIPT_STATUS_ON_PLAYER, transcriptStatus };
};

export const updateVideoPlayerName = name => {
  return {
    type: UPDATE_VIDEO_PLAYER_NAME,
    name,
  };
};

export const updateVideoPlayerOwner = (displayName, avatar) => {
  return {
    type: UPDATE_VIDEO_PLAYER_OWNER,
    displayName,
    avatar,
  };
};

export const updateFillerWords = (fillerWords, fillerWordRemoval) => {
  return {
    type: UPDATE_FILLER_WORDS,
    fillerWords,
    fillerWordRemoval,
  };
};

export const updateFillerWordHighlight = (fillerWordHighlight = false) => {
  return {
    type: UPDATE_FILLER_WORD_HIGHLIGHT,
    fillerWordHighlight,
  };
};

export const updateIsFillerRemovalFTUX = (isFillerRemovalFTUX = false) => {
  return {
    type: UPDATE_IS_FILLER_REMOVAL_FTUX,
    isFillerRemovalFTUX,
  };
};

export const updateTrimmingFillerWords = (isTrimmingFillerWords = false) => {
  return {
    type: UPDATE_IS_TRIMMING_FILLER_WORDS,
    isTrimmingFillerWords,
  };
};
